import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';

export const SEO = ({ title, description, path = '' }) => {
  const { language } = useLanguage();
  const baseUrl = process.env.REACT_APP_SITE_URL || 'https://paraguanah2.green';
  const fullUrl = `${baseUrl}${path}`;

  const siteName = 'Paraguana Hydrogen Gateway';
  const defaultDescription = language === 'es'
    ? 'Plataforma de hidrógeno verde con escala industrial y conectividad marítima estratégica desde la Península de Paraguaná.'
    : 'Industrial-scale green hydrogen platform with strategic maritime connectivity from the Paraguaná Peninsula.';

  const finalTitle = title ? `${title} | ${siteName}` : `${siteName} — La Puerta Verde del Caribe`;
  const finalDesc = description || defaultDescription;
  const ogImage = `${baseUrl}/logo.png`;

  return (
    <Helmet>
      <html lang={language} />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={siteName} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={language === 'es' ? 'es_ES' : 'en_US'} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Alternate language links */}
      <link rel="alternate" hrefLang="es" href={fullUrl} />
      <link rel="alternate" hrefLang="en" href={fullUrl} />
      <link rel="alternate" hrefLang="x-default" href={fullUrl} />
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};
